import { Form, FormGroup } from "@angular/forms";
import { ToastService } from "../blocks";
import { UserSessionService } from "../shared";

export class StockPoHelper {
    constructor(public _toastService: ToastService  ) { }
    items: Array<any> = [];
    customObj: any = <any>{};
    roundFinancialFigures:number;
    onNuberChange(e: any, row: any, setting: any, items?: any[],RoundFinancialFigures?:number): any {
        this.items = items;
     this.roundFinancialFigures=RoundFinancialFigures
        if (row['discount'] == '' || row['discount'] == undefined) {
            row['discount'] = 0;
        }
        if (+row['unitCost'] > +row['unitSale']) {
            this._toastService.activateMsg('UI2020');
        }
        if (setting.defaultDiscountAttribute == 1) {
            if (row['number'] != (null || undefined)) {

                let disVal = this.GetDisVal(row, 'unitSale');
                let addDisVal = this.GetAddDisVal(row, 'unitSale', disVal);
                let taxVal = this.GetTaxVal(row, 'unitSale', disVal, addDisVal);
                row['totCostAfterDis'] = row['unitSale'] * row['number'] //اجمالى البيع قبل الخصم معلش بقى فى اللخبطة
                row['netOfPiceitem'] = row['unitSale'] * row['number'];//اجمالى البيع
                row['netOfPiceitem']=row['netOfPiceitem'].toFixed(this.roundFinancialFigures);

                row['itemtaxMoney'] = taxVal
                row['itemtaxMoney']=row['itemtaxMoney'].toFixed(this.roundFinancialFigures);
                if (setting.addTaxToItemCostSetting == 2) {
                    taxVal = 0
                }
                row['netOfPiceUnits'] = +row['netOfPiceitem'] - disVal - addDisVal + taxVal;//اجمالى التكلفة
                row['netOfPiceUnits']=row['netOfPiceUnits'].toFixed(this.roundFinancialFigures);
            }
        }
        else {
            if (row['number'] != (null || undefined)) {
                let disVal = this.GetDisVal(row, 'unitCost');
                let addDisVal = this.GetAddDisVal(row, 'unitCost', disVal);
                let taxVal = this.GetTaxVal(row, 'unitCost', disVal, addDisVal);
                row['totCostAfterDis'] = row['unitCost'] * row['number'] //اجمالى البيع قبل الخصم معلش بقى فى اللخبطة
                row['netOfPiceitem'] = row['unitSale'] * row['number'];//اجمالى البيع
                row['netOfPiceitem']=row['netOfPiceitem'].toFixed(this.roundFinancialFigures);

                row['itemtaxMoney'] = taxVal
                row['itemtaxMoney']=row['itemtaxMoney'].toFixed(this.roundFinancialFigures);

                if (setting.addTaxToItemCostSetting == 2) {
                    taxVal = 0
                }
                row['netOfPiceUnits'] = +row['totCostAfterDis'] - disVal - addDisVal + taxVal;//اجمالى التكلفة
                row['netOfPiceUnits']=row['netOfPiceUnits'].toFixed(this.roundFinancialFigures);

            }
        }
        if (setting.defaultDiscountAttribute == 1)
            row['unitCost'] = +(row['netOfPiceUnits'] / row['number']).toFixed(this.roundFinancialFigures);
        this.expenseValueChange(setting);
        this.calculatTotals(setting);
        return { row, customObj: this.customObj };
    }




    GetAddDisVal(row: any, disOn: string, disVal: number) {
        if (row['additionalDiscountType'] == 1 && row['additionalDiscount'] > 0) {
            return +row['additionalDiscount'];
        }
        if (row['additionalDiscountType'] == 2 && row['additionalDiscount'] > 0) {//1:val, 2:percentage
            return ((row[disOn] * row['number']) - disVal) * row['additionalDiscount'] / 100;
        }
        return 0;
    }


    GetTaxVal(row: any, disOn: string, disVal: number, addDisVal: number) {
        if (row['taxType'] == 1 && row['tax'] > 0) {
            return +row['tax'];
        }
        if (row['taxType'] == 2 && row['tax'] > 0) {//1:val, 2:percentage
            return ((row[disOn] * row['number']) - disVal - addDisVal) * row['tax'] / 100;
        }
        return 0;
    }

    GetDisVal(row: any, disOn: string) {
        if (row['discountType'] == 1 && row['discount'] > 0) {//1:val, 2:percentage
            return +row['discount'];

        }
        if (row['discountType'] == 2 && row['discount'] > 0) {//1:val, 2:percentage
            return (row[disOn] * row['number']) * row['discount'] / 100;
        }
        return 0;
    }

    calculateTheValueOfPercentage(value: number, percentage: number) {
        if (value && percentage) {
            return value * percentage;
        }
        else {
            return 0;
        }
    }


    calculatTotals(setting: any) {
        if (this.items == null || this.items == undefined) {
            return;
        }
        if (setting.defaultDiscountAttribute == 2) {
            this.CalculateTotalsByCost(setting);
        }
        else {
            this.CalculateTotalsBySale(setting);

        }
        this.MasterDiscountValueChange(setting.discount, setting);

    }
    CalculateTotalsBySale(setting: any) {
        let TotalSale = 0, TotalCostAfterDis = 0, NetCost = 0, itemtaxMoney = 0;
        for (var i = 0; i < this.items.length; i++) {
            TotalSale += +(this.items[i].netOfPiceitem);
            itemtaxMoney += +(this.items[i].itemtaxMoney);
            if (this.items[i].number != undefined || this.items[i].number != null) {
                TotalCostAfterDis += +(this.items[i].netOfPiceUnits);
            }
        }
        NetCost = TotalSale;
        this.fillTotals(TotalSale, TotalCostAfterDis, TotalCostAfterDis, itemtaxMoney, setting);
    }

    CalculateTotalsByCost(setting: any) {
        
        let TotalCost = 0, TotalCostAfterDis = 0, itemtaxMoney = 0, TotalSale = 0;
        for (var i = 0; i < this.items.length; i++) {
            TotalCost += +(this.items[i].totCostAfterDis);
            TotalCostAfterDis += +(this.items[i].netOfPiceUnits);
            TotalSale += +(this.items[i].netOfPiceitem);
            itemtaxMoney += +(this.items[i].itemtaxMoney);
        }
    
        this.fillTotals(TotalSale, TotalCostAfterDis, TotalCost, itemtaxMoney, setting)
    }
    fillTotals(TotalSale: number, GrossTotalCost: number, TotalCost: number, itemtaxMoney: number, setting: any) {
        this.customObj.totalSale = TotalSale.toFixed(this.roundFinancialFigures);
        this.customObj.totalCost = GrossTotalCost.toFixed(this.roundFinancialFigures);
        this.customObj.totalNetCost = GrossTotalCost.toFixed(this.roundFinancialFigures);
        this.customObj.grossTotalCost = GrossTotalCost.toFixed(this.roundFinancialFigures);
        this.customObj.poTotalTaxMoney =  itemtaxMoney.toFixed(this.roundFinancialFigures)

        let totalGift = this.sumTotalGift(setting);
        this.customObj.grossTotalCost = this.customObj.grossTotalCost - totalGift;
        if (setting.totalExpensed > 0)
            this.addTotalExpensed(this.customObj.totalSale,this.customObj.grossTotalCost, setting);
    }
    addTotalExpensed(TotalSale: number, GrossTotalCost: number, setting: any) {
        if (setting.defaultDiscountAttribute == 2) {//cost
            this.customObj.totalCost = GrossTotalCost + setting.totalExpensed;
            this.customObj.totalNetCost = GrossTotalCost + setting.totalExpensed;
            this.customObj.grossTotalCost = GrossTotalCost + setting.totalExpensed;
        } else {//البيع
            this.customObj.totalCost = GrossTotalCost + setting.totalExpensed;
            this.customObj.totalNetCost = GrossTotalCost + setting.totalExpensed;
            this.customObj.grossTotalCost = GrossTotalCost + setting.totalExpensed;
            this.customObj.totalSale = TotalSale + setting.totalExpensed;
        }


    }
    expenseValueChange(setting: any) {
        let totalOfTotalCost = this.getTotalCostTable();
        if (!(totalOfTotalCost > 0)) {
            totalOfTotalCost = 0;
        }
        for (var i = 0; i < this.items.length; i++) {
            if (totalOfTotalCost === 0) {
                this.items[i].expensedValue =0;
            } else {
                this.items[i].expensedValue = (+this.items[i].netOfPiceUnits * setting.totalExpensed) / totalOfTotalCost;
                if(isNaN(this.items[i].expensedValue)){
                    this.items[i].expensedValue=0
                }
                this.items[i].expensedValue = +this.items[i].expensedValue.toFixed(this.roundFinancialFigures);
                if (this.items[i].expensedValue > 0) {
                    this.items[i].costWithExpenses =  (this.items[i].expensedValue / this.items[i].number) + (this.items[i].unitCost);
                    this.items[i].costWithExpenses = +this.items[i].costWithExpenses.toFixed(this.roundFinancialFigures);
                }else {
                    this.items[i].costWithExpenses = +this.items[i].unitCost;
                    this.items[i].costWithExpenses = this.items[i].costWithExpenses.toFixed(this.roundFinancialFigures);
                }
                if (!(this.items[i].expensedValue > 0)) {
                    this.items[i].expensedValue = 0;
                }
            }
        }
    }
    getTotalCostTable() {
        var dataArray = this.items.map(function (o) { return +o.netOfPiceUnits });
        let totalOfTotalCost = dataArray.reduce(function (a, b) { return a + b; });
        return totalOfTotalCost
    }
    sumTotalGift(setting: any) {
        let totalGift = 0
        for (var i = 0; i < this.items.length; i++) {
            if (this.items[i].gift != undefined && this.items[i].gift == 1) {
                if (setting.defaultDiscountAttribute == 2) {
                    totalGift += +(this.items[i].number) * +(this.items[i].unitCost);
                } else {
                    totalGift += +(this.items[i].number) * +(this.items[i].unitSale);
                }
            }
        }
        return totalGift;
    }
    MasterDiscountValueChange(val: number, setting: any) {
        if (val == undefined) val = 0
        val = +(val);


        if (this.customObj.grossTotalCost == undefined ||
            this.customObj.grossTotalCost == null ||
            this.customObj.grossTotalCost == 0) {
            this._toastService.activateMsg('UI2020');
        }
        else {
            let totalcost = this.customObj.grossTotalCost;
            if (setting.percentOrValue == undefined || setting.percentOrValue == null) {
                setting.percentOrValue = 1//done
            }
            if (setting.percentOrValue == 2) {  //done
                if (val > 100) {

                    this._toastService.activateMsg("UI258");
                    return;
                } else {
                    let dis = totalcost * (val / 100);
                    let netcost = totalcost - dis;
                    this.customObj.totalNetCost = netcost;
                }

            }
            else if (setting.percentOrValue == 1) {//done                      
                if (val > totalcost) {
                    this._toastService.activateMsg("UI114");
                    return;
                } else {
                    let netcost = totalcost - val;
                    this.customObj.totalNetCost = netcost;
                }
            }
        }
    }
}